import React, { useState, useMemo, useRef, useEffect } from 'react';
import ReactPlayer from 'react-player';
import styles from './DebaterColumn.module.css';
import AudioRecorder from './../AudioRecorder/AudioRecorder';
import AudioMessageCard from './../AudioMessageCard/AudioMessageCard';
import TextMessageCard from './../TextMessageCard/TextMessageCard';
import { useAuth } from "../../../utils/AuthContext/authcontext";
import { uploadAudioBlob } from '../../../utils/AudioUploader/AudioUploader';
import Button from '../../ui/Button';
import { useTranslation } from 'react-i18next';
import { storage, firestore, auth }  from "../../../firebase/firebase.js";
import {
  collection,
  addDoc,
  getDoc,
  updateDoc,
  query,
  orderBy,
  onSnapshot,
  increment,
  doc,
  arrayUnion,
  setDoc,
  serverTimestamp
} from 'firebase/firestore';

const DebaterColumn = ({ arenaMeta, isSingleTeam = false, position = 'left', onFilterMessage, gfocusThreadId = null, messages, arenaId, iscurrentUserInTeam, user, onAudioSave, onRecordingStarted,state,activeTurn,arena, formatId, team, actions, capabilities,moderatorPresent = false, isModerator = null, replyToRecord = null, OnhandleReply, groupBy = 'round' /* or 'speaker'*/ }) => {
  const { t } = useTranslation();
  const [playingId, setPlayingId] = useState(null);
  const playerRef = useRef(null);
  const recorderRef = useRef();
  const [activeAudioId, setActiveAudioId] = useState(null);
  const audioRefs = useRef({});
  const [viewOrder, setViewOrder] = useState('oldest'); // 'oldest', 'newest', 'most-recent'
  const [showMostRecent, setMostRecent] = useState(true);
  const [allowScroll, setallowScroll] = useState(false);
  const [showOnlyScores, setShowOnlyScores] = useState(false);
  const [recentLimit, setRecentLimit] = useState(5);
  const [visibleCount, setVisibleCount] = useState(5);
  const [focusThreadId, setFocusThreadId] = useState(null);
  const [groupByState, setGroupBy] = useState(groupBy);
  const endRef = useRef(null);
  const { userData, searchbyUsersId } = useAuth();

  const [filteredMessage, setFilteredMessage] = useState([]);

  const isActiveSpeaker = activeTurn?.activeSpeakers?.find(s => s.speakerId === user.uid)?.speakerId  || null;
  const IsCurrentRecSpeaker = activeTurn?.activeSpeakers?.find(s => s.currentSpeaker === true && s.speakerId !== user.uid)?.speakerId || null;

	const hasSpectatorRole = () => {
   	 return arena?.spectators?.some(s => s.uid === user?.uid);
  	};

  //console.log(activeTurn?.activeSpeakers, user.uid, isActiveSpeaker, IsCurrentRecSpeaker);
  let currentRound = state?.currentRound || null;
  //console.log(activeTurn,state);
  useEffect(() => {
    setFocusThreadId(gfocusThreadId);
  }, [gfocusThreadId]);

  const enrichMessagesWithUser = async (visibleMessages) =>  {
	const cache = {};

	return Promise.all(
		visibleMessages.map(async (msg) => {
		if (!cache[msg.senderId]) {
			cache[msg.senderId] = await searchbyUsersId(msg.senderId);
		}

		return {
			...msg,
			user: cache[msg.senderId],
		};
		})
	);
	}

	useEffect(() => {
	const process = async () => {
		if (!messages) return;
		const teamIds = new Set(team?.map(s => s.uid));
		const enriched = await enrichMessagesWithUser(messages);
		const filtered = enriched.filter(a => teamIds.has(a.senderId));
		// const filtered = enriched.filter(a => team?.some(s => s?.uid === a.senderId));
		setFilteredMessage(filtered);
	};

	process();
	}, [messages, team]);

  /*useEffect(() => {
    if(replyToRecord) {
      setallowScroll(true);
    }
  }, [replyToRecord]);*/
  
  //console.log('Messages received in DebaterColumn:', team.length);
  const handlePlay = id => {
    setPlayingId(prev => (prev === id ? null : id));
  };

  /*const filteredMessage = messages?.filter(a => {
	var currentUserOpp = team?.find(s => s?.uid === a.senderId) || null;
	if(currentUserOpp != null && currentUserOpp != undefined) {
		return true;
	}
	return false;
  });*/

  

  const ordered = useMemo(() => {
    
	const filteredMessageCleaned = isModerator && showOnlyScores === true ? filteredMessage.filter(m => (m.score) > 0) : filteredMessage;
	
	const arr = filteredMessage ? [...filteredMessageCleaned] : [];

    var orderedMessages = viewOrder === 'newest' ? arr.reverse() : arr;
	if (filteredMessageCleaned && showMostRecent === true) {
	   // Show newest first in "most-recent"
	  orderedMessages = viewOrder === 'newest' ? [...filteredMessageCleaned].slice(-recentLimit).reverse() : [...filteredMessageCleaned].slice(-recentLimit);
	}
	return orderedMessages;
	
  }, [filteredMessage, viewOrder, recentLimit, showOnlyScores, isModerator]);

  const filtered = useMemo(() => {
    return focusThreadId  ? ordered.filter(m => (m.threadid) === focusThreadId) : ordered;
  }, [ordered, focusThreadId]);

  const visibleMessages = useMemo(() => {
    if (showMostRecent === true) {
		return filtered.slice(-visibleCount);
	}
	else {
		return filtered.slice(0, visibleCount);
	}
  }, [filtered, visibleCount]);

 /* useEffect(() => {
	//console.log('Visible messages updated:', visibleMessages, filteredMessage, visibleCount);
    if (visibleMessages.length > 0 && endRef.current && allowScroll == true) {
      //endRef.current.scrollIntoView({ behavior: 'smooth' });
	  setallowScroll(false);
    }
  }, [visibleMessages]);*/


	/*useEffect(() => {
	  if (viewOrder === 'newest' && endRef.current) {
		endRef.current.scrollIntoView({
		  behavior: 'smooth',
		  block: 'end'
		});
	  }
	}, [visibleMessages, viewOrder]);*/

  const playThread = (threadId) => {
	setFocusThreadId(threadId);
	if(onFilterMessage)onFilterMessage(threadId);
  };

  const renderGrouped = () => {
    if (!groupByState) return visibleMessages.map(renderCard);

	//console.log('Grouping messages by:', groupByState, visibleMessages);
    const groups = visibleMessages.reduce((acc, m) => {
      const key = groupByState === 'speaker' ? m?.user?.[0]?.username : m?.round;
      if (!acc[key]) acc[key] = [];
      acc[key].push(m);
      return acc;
    }, {});

    return Object.entries(groups).map(([key, msgs]) => (
      <details key={key} open>
        <summary>{groupByState === 'speaker' ? `Speaker: ${key}` : `Round ${key}`}</summary>
        {msgs.map(renderCard)}
      </details>
    ));
  };

  function renderCard(msg, idx) {
    const threadId = msg.threadid || '';//msg.replyto || msg.id;
	const showRound = msg.round !== currentRound;
	//currentRound = msg.round;
	
	return (
	   <div key={msg.id} ref={viewOrder === 'newest' ? idx === 0 ? endRef : null : idx === visibleMessages.length - 1 ? endRef : null}>
		{false && showRound && (
		  <div style={{ textAlign: 'center', margin: '1rem 0', fontWeight: 'bold', color: '#fca311' }}>Round {msg.round}
		  </div>
		)}
		{msg.type === 'audio' ? (
		  <AudioMessageCard
			audioUrl={msg.audioUrl}
			msgid={msg.id}
			user={user}
			senderName={msg.senderName || msg.senderId}
			timestamp={msg.timestamp?.toDate?.()}
			duration={msg.duration}
			transcript={msg.transcript}
			acceptable={msg.acceptable}
			score={msg.score}
			replyto={msg.replyto}
			threadid={msg.threadid}
			isPlaying={activeAudioId === msg.id}
			onPlay={() => handlePlaying(msg.id)}
			onReply={OnhandleReply}
			onPlayTread={(threadId) => playThread(threadId)}
			onPause={() => handlePause(msg.id)}
			onScore={(isModerator && capabilities?.canScore === true) || (hasSpectatorRole() && arenaMeta?.spectators?.features.includes('postVote') && arenaMeta?.spectators?.features.includes('preVote'))  ? delta => handleScore(msg.id, msg.senderId, delta) : null}
			onhandleAcceptance={isModerator ? status => {status == 1 ? handleApprove(msg.id) : handleReject(msg.id)} : null}
			editableTranscript={isModerator}
			onTranscriptUpdate={isModerator ? newText => handleTranscriptUpdate(msg.id, newText) : null}
			ref={el => (audioRefs.current[msg.id] = el)}/>
		) : (
		  <TextMessageCard
			text={msg.text}
			senderName={msg.senderName || msg.senderId}
			timestamp={msg.timestamp?.toDate?.()}
		  />
		)}
	  </div>
	);
  }
  
	const handlePlaying = id => {
		if (activeAudioId && activeAudioId !== id && audioRefs.current[activeAudioId]) {
			audioRefs.current[activeAudioId].pause();
		}
		setActiveAudioId(id);
		audioRefs.current[id]?.play();
	};

	const handlePause = id => {
		setActiveAudioId(null);
		audioRefs.current[id]?.pause();
	};

	const updateScroll = (objref) => {
		const el = objref.current;

		if (!el) return;

		const rect = el.getBoundingClientRect();
		const viewportHeight = window.innerHeight;

		// allow partial visibility
		const isInView =
		rect.top < viewportHeight * 0.8 &&
		rect.bottom > viewportHeight * 0.2;

		if (!isInView) {
			el.scrollIntoView({ behavior: 'smooth' });
		}
	};

	const handleAudioSave = async (blob, duration, triggerRecording ) => {
		await onAudioSave(blob, duration, triggerRecording);
		if (visibleMessages.length > 0 && endRef.current) {
			updateScroll(endRef);
		}
	};


	const handleScore = async (messageId, senderId, delta) => {
		const msgRef = doc(firestore, 'arenas', arenaId, 'messages', messageId);
		await updateDoc(msgRef, { score: increment(delta) });
		if(actions && actions.updateScores && capabilities?.canScore === true) {
			actions.updateScores(senderId, delta);
		}
	};

	const handleReject = async (messageId) => {
		const msgRef = doc(firestore, 'arenas', arenaId, 'messages', messageId);
		await updateDoc(msgRef, { acceptable: 0 });
	};

	const handleApprove = async (messageId) => {
		const msgRef = doc(firestore, 'arenas', arenaId, 'messages', messageId);
		await updateDoc(msgRef, { acceptable: 1 });
	};

	const handleTranscriptUpdate = async (messageId, newText) => {
		const msgRef = doc(firestore, 'arenas', arenaId, 'messages', messageId);
		await updateDoc(msgRef, { transcript: newText });
	};



  return (
    <div className={` ${moderatorPresent ? isSingleTeam == true ? styles.columnsemi : styles.column : styles.columnfull} ${styles[position]}`}>
	  {iscurrentUserInTeam == true && state?.status === 'active' &&  isActiveSpeaker != null && IsCurrentRecSpeaker == null ? <AudioRecorder ref={recorderRef} onRecordingStarted={onRecordingStarted} onSave={handleAudioSave} triggerRecording={replyToRecord} maxDuration={activeTurn?.remainingTimeForTurn ? activeTurn?.remainingTimeForTurn : null} /> : <></>}

	{filteredMessage?.length == 0  || filteredMessage?.length == undefined ? 
		<div className={styles.nomessages}>
		{t('ui.debateArenanoMessages')}
	</div> : <></>}

      {filteredMessage?.length > 0 ? <div className={styles.controls}>
        <Button variant="ghost" onClick={() => setViewOrder(o => (o === 'oldest' ? 'newest' : 'oldest'))}>
          Sort: {viewOrder === 'oldest' ? 'Oldest First' : 'Newest First'}
        </Button>
		
        {showMostRecent == false && visibleCount < filtered.length && (
          <Button variant="ghost" onClick={() => setVisibleCount(c => c + 5)}>
            Load More
          </Button>
        )}
	
		{showMostRecent && recentLimit < filteredMessage.length && (
		  <Button  variant="ghost" onClick={() => {setRecentLimit(r => r + 5); setVisibleCount(c => c + 5);}}>
			Load More
		  </Button>
		)}	
	
        {focusThreadId && (
          <Button  variant="ghost" onClick={() => playThread(null)}>Show All Threads</Button>
        )}
      </div> : <></>}
	
	
	{filteredMessage?.length > 0 && team?.length > 0 && (<div className={styles.controls}>
	<Button  variant="ghost" onClick={() => setGroupBy(g => g === 'round' ? 'speaker' : 'round')}>
		Group by: {groupByState === 'round' ? 'Speaker' : 'Round'}
	</Button>
	</div>)}

	{filteredMessage?.length > 0 && isModerator && (<div className={styles.controls}>
		<Button  variant="ghost" onClick={() => {setShowOnlyScores(s => !s);}}>
			{showOnlyScores == false ? 'Show Scored Messages' : 'Show All Messages'}
		</Button>
	</div>)}

	{filteredMessage?.length > 0 ? <div className={styles.threadMap}>
	  {/*<label htmlFor="threadSelector">View Thread:</label>*/}
	  <select
		id="threadSelector"
		value={focusThreadId || ''}
		onChange={e => playThread(e.target.value || null)}
		className={styles.threadSelect}>
		<option value="">All Threads</option>
		{Array.from(
		new Set(
			filtered
			.map(m => m.threadid)
			.filter(tid => tid != null) // removes undefined + null
		)
		).map((tid, i) => (
		<option key={i} value={tid}>
			Thread {tid.slice(-5)}
		</option>
		))}
	  </select>	
	</div> : <></>}

	{/*  <div ref={endRef} />*/}
    <div className={styles.audioThread}>
	   <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
      {renderGrouped()}
	  </div>
	  </div>
    </div>
  );

/*
  return (
    <div className={`${styles.column} ${styles[position]}`}>
	  {iscurrentUserInTeam == true ? <AudioRecorder ref={recorderRef} onSave={onAudioSave} triggerRecording={replyToRecord} /> : <></>}
      <div className={styles.audioThread}>
		<div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
		  {filteredMessage.map(msg => {
			const showRound = msg.round !== currentRound;
			currentRound = msg.round;

			return (
			  <React.Fragment key={msg.id}>
				{false && showRound && (
				  <div style={{ textAlign: 'center', margin: '1rem 0', fontWeight: 'bold', color: '#fca311' }}> ??�Round {msg.round}
				  </div>
				)}
				{msg.type === 'audio' ? (
				  <AudioMessageCard
					audioUrl={msg.audioUrl}
					msgid={msg.id}
					user={user}
					senderName={msg.senderName || msg.senderId}
					timestamp={msg.timestamp?.toDate?.()}
					duration={msg.duration}
					transcript={msg.transcript}
					score={msg.score}
					replyto={msg.replyto}
					threadid={msg.threadid}
					isPlaying={activeAudioId === msg.id}
					onPlay={() => handlePlaying(msg.id)}
					onReply={OnhandleReply}
					onPause={() => handlePause(msg.id)}
					onScore={isModerator ? delta => handleScore(msg.id, delta) : null}
					editableTranscript={isModerator}
					onTranscriptUpdate={isModerator ? newText => handleTranscriptUpdate(msg.id, newText) : null}
					ref={el => (audioRefs.current[msg.id] = el)}
				  />
				) : (
				  <TextMessageCard
					text={msg.text}
					senderName={msg.senderName || msg.senderId}
					timestamp={msg.timestamp?.toDate?.()}
				  />
				)}
			  </React.Fragment>
			);
		  })}
		</div>
      </div>
    </div>
  );
*/
};

export default DebaterColumn;

